import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import {
  fetchUsers,
  fetchInstitutes,
  setLoading,
} from '../../redux/actions';
import ContentBox from '../../components/layout/ContentBox';
import {
  Institute,
  RootState,
  UserManagementRow,
} from '../../redux/types';
import { convertToQid } from '../../utilities/stringHelper';
import { ColumnObject } from '../../components/layout/table/ZerpaTable';
import UserManagement from '../../components/user/UserManagement';
import { useAppDispatch } from '../../hooks/reduxHooks';

const columns: ColumnObject[] = [
  {
    keyName: '',
    text: 'select',
    type: 'checkbox',
  },
  {
    keyName: 'userId',
    text: 'Quip Id',
    sortable: true,
  },
  {
    keyName: 'title',
    text: <FormattedMessage id="trialdetails.title" />,
    sortable: true,
  },
  {
    keyName: 'firstname',
    text: <FormattedMessage id="userDetails.firstname" />,
    sortable: true,
  },
  {
    keyName: 'surname',
    text: <FormattedMessage id="userDetails.surname" />,
    sortable: true,
  },
  {
    keyName: 'email',
    text: <FormattedMessage id="userDetails.email" />,
    sortable: true,
  },
  {
    keyName: 'position',
    text: 'Position',
    sortable: true,
  },
  {
    keyName: 'instituteName',
    text: <FormattedMessage id="trialdetails.attendeeInstitute" />,
    sortable: true,
  },
  {
    keyName: 'instituteCity',
    text: 'Institute City',
    sortable: true,
  },
  {
    keyName: 'instituteZip',
    text: 'Institute Zip Code',
    sortable: true,
  },
  {
    keyName: 'instituteCountry',
    text: 'Country',
    sortable: true,
  },
  {
    keyName: 'instituteId',
    text: 'Institute Id',
    sortable: true,
  },
];

const UserManagementView: React.FC = () => {
  const dispatch = useAppDispatch();
  const usersIdList = useSelector((state: RootState) => state.users.allIds);
  const userByIds = useSelector((state: RootState) => state.users.byId);
  const instituteByIds = useSelector((state: RootState) => state.institute.byId);

  useEffect(() => {
    dispatch(setLoading(true));
    dispatch(fetchUsers());
  }, [dispatch]);

  useEffect(() => {
    if (!instituteByIds) {
      dispatch(setLoading(true));
      dispatch(fetchInstitutes());
    }
  }, [instituteByIds, dispatch]);

  useEffect(() => {
    if (userByIds !== undefined && instituteByIds !== undefined) {
      dispatch(setLoading(false));
    }
  }, [userByIds, instituteByIds, dispatch]);

  const usersListFlat: UserManagementRow[] | undefined = userByIds
  && instituteByIds
  && usersIdList?.map((userId: number) => {
    const user = userByIds[userId];
    const { instituteId, userCountry } = user;
    const institute: Institute | undefined = instituteByIds[instituteId];
    return {
      ...user,
      userId: convertToQid(userId, institute?.country || userCountry),
      instituteName: institute?.name,
      instituteCity: institute?.city,
      instituteZip: institute?.zip,
      instituteCountry: institute?.country,
    };
  });

  return (
    <>
      <ContentBox title={<FormattedMessage id="admindetails.usersManagement" />}>
        <UserManagement
          userTableColumns={columns}
          userTableRows={usersListFlat}
        />
      </ContentBox>
    </>
  );
};

export default UserManagementView;
